import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import logo from '../assets/fleetorder-logo.png';
import './Navbar.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false); // dropdown state

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => {
    setMenuOpen(false);
    setProductsOpen(false);
  };
  const navigate = useNavigate()

  const toggleProducts = () => setProductsOpen(prev => !prev);

  const handleRedirectToContact = () =>{
    navigate('/contactus')
  }

  return (
    <header className="custom-header">

      <div className="custom-logo-container">
        <Link to="/">
          <img src={logo} alt="Logo" className="custom-logo" />
        </Link>
      </div>

      <nav className={`custom-nav-links ${menuOpen ? "custom-active" : ""}`}>
        <div className="custom-dropdown">
          <button 
            className="custom-link custom-dropdown-btn" 
            onClick={toggleProducts}
          >
            Products
          </button>
          {productsOpen && (
            <div className="custom-dropdown-content">
              <NavLink to="/products/fleet-eats" className="custom-dropdown-link" onClick={closeMenu}>Fleet Eats</NavLink>
              <NavLink to="/products/fleet-mart" className="custom-dropdown-link" onClick={closeMenu}>Fleet Mart</NavLink>
              <NavLink to="/products/fleet-stay" className="custom-dropdown-link" onClick={closeMenu}>Fleet Stay</NavLink>
              <NavLink to="/products/fleet-office" className="custom-dropdown-link" onClick={closeMenu}>Fleet Office</NavLink>
            </div>
          )}
        </div>
        {/* <NavLink to="/" className="custom-link" onClick={closeMenu} end>H</NavLink> */}
        <NavLink to="/aboutus" className="custom-link" onClick={closeMenu}>About Us</NavLink>

        <NavLink to="/contactus" className="custom-link" onClick={closeMenu}>Contact Us</NavLink>
      </nav>

      <div className="custom-header-right">
        {/* <NavLink to="" className="custom-button" onClick={handleRedirectToContact}>Book Demo</NavLink> */}
        <button className="custom-button" onClick={handleRedirectToContact}>Book Demo</button>


        <div
          className={`custom-nav-toggle ${menuOpen ? "custom-open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleMenu(); }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
